/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, ProductCard, Skeleton } from '@coursera/cds-core';

const styles = {
  container: css`
    /* CDS ProductCard style overrides */
    .cds-ProductCard-listSkeleton {
      flex-direction: row !important;
    }

    .cds-ProductCard-listSkeletonPreviewContainer {
      flex: unset !important;
    }

    .cds-ProductCard-listSkeleton .cds-ProductCard-listSkeletonPreview {
      height: var(--list-img-size) !important;
      width: var(--list-img-size) !important;
      aspect-ratio: unset !important;
    }
  `,
};

const CompactCollectionsPlaceholder = () => {
  return (
    <div css={styles.container}>
      <div>
        <Skeleton variant="text" width="50%" />
      </div>
      <Grid container spacing={8}>
        {Array.from(Array(3).keys()).map((value) => (
          <Grid item xs={12} key={value}>
            <ProductCard variant="list" productType="role" loading={true} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CompactCollectionsPlaceholder;
